'use client'

import { useState } from 'react'
import { WordsToMinutes } from '@/components/tools/words-to-minutes'
import { countWords } from '@/components/tools/word-counter'
import { InlineScriptCheck } from '@/components/seo/InlineScriptCheck'
import { Button } from '@/components/ui/button'
import { trackCalcCheckClick } from '@/lib/analytics'

// This page was the one calculator with no paste box anywhere (10.9k
// impressions over 28 days to 2026-10-11), so the "Paste script" mode above and
// the free check below now hand the same draft to each other: paste once, and
// the check runs on it. page.tsx is a server component, so the shared text lives
// here; its tables, FAQ and CTAs stay in page.tsx.
const PAGE = 'tool-words-to-minutes'
/** Matches the InlineScriptCheck `page` prop, so the click and the box line up. */
const CHECK_ID = 'words-to-minutes-check'
// Below this the check has nothing to say about hook or structure, so the
// button stays hidden rather than inviting a submission the API would refuse.
const MIN_CHECK_WORDS = 150

export function WordsToMinutesContent() {
  const [text, setText] = useState('')
  const words = countWords(text)

  const handleCheckClick = () => {
    trackCalcCheckClick({ page: PAGE, word_count: words })
    document.getElementById(CHECK_ID)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  return (
    <>
      <WordsToMinutes script={text} onScriptChange={setText} />

      {words >= MIN_CHECK_WORDS && (
        <div className="mt-6 rounded-lg border border-primary/30 bg-primary/5 p-5 text-center">
          <Button
            type="button"
            size="lg"
            onClick={handleCheckClick}
            className="h-12 w-full px-6 text-[15px] font-medium sm:h-11"
          >
            Check this script (free)
          </Button>
          <p className="mt-2 text-xs text-muted-foreground">
            Hook, structure, and pacing scores plus the single biggest issue quoted from your own
            lines. No login.
          </p>
        </div>
      )}

      {/* Right after the calculator output the visitor has a script and a
          length in hand, so the free check itself sits here rather than a
          banner that links to it. The paste box is already filled from the
          "Paste script" mode above; the click does not submit. */}
      <div className="mt-6">
        <InlineScriptCheck
          id={CHECK_ID}
          initialScript={text}
          page={PAGE}
          heading="Know the length? Check the script itself, free"
          subheading="Paste the draft you just measured. You get hook, structure and pacing scores and the one issue costing it the most, quoted from your own lines."
        />
      </div>
    </>
  )
}
